// extracted by mini-css-extract-plugin
export var black = "#000";
export var gothic = "\"trade-gothic-next\",sans-serif";
export var inter = "\"Inter\",sans-serif";
export var lg = "992";
export var md = "768";
export var primary = "#ff0005";
export var sm = "576";
export var white = "#fff";
export var xl = "1440";
export var xs = "425";